import { render, staticRenderFns } from "./my-motions-status-viewer-component.vue?vue&type=template&id=6a860c3a&scoped=true"
import script from "./my-motions-status-viewer-component.ts?vue&type=script&lang=ts&external"
export * from "./my-motions-status-viewer-component.ts?vue&type=script&lang=ts&external"
import style0 from "./my-motions-status-viewer-component.scss?vue&type=style&index=0&id=6a860c3a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a860c3a",
  null
  
)

export default component.exports